// extracted by mini-css-extract-plugin
export default {"home":"styles_home__D3hDY","home_header":"styles_home_header__toQw5","home_app":"styles_home_app__NHvev","scrollbar-hide":"styles_scrollbar-hide__Xa-C9"};